import { Product, Testimonial } from './types';

// Products data
export const products: Product[] = [
  {
    id: 1,
    name: "Premium Wheat Seeds",
    slug: "premium-wheat-seeds",
    description: "High-yielding wheat varieties with excellent disease resistance and drought tolerance. Our top performer for Indian agricultural conditions.",
    category: "Major Seeds",
    imageUrl: "https://images.unsplash.com/photo-1574323347407-f5e1ed40c17c?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=MnwxfDB8MXxyYW5kb218MHx8d2hlYXQgZmllbGR8fHx8fHwxNjk3ODM4ODY1&ixlib=rb-4.0.3&q=80&w=500",
    featured: true
  },
  {
    id: 2,
    name: "Hybrid Maize Seeds",
    slug: "hybrid-maize-seeds",
    description: "High-yielding maize hybrids with robust stalks and exceptional drought tolerance, designed for maximum productivity in diverse growing conditions.",
    category: "Major Seeds",
    imageUrl: "https://images.unsplash.com/photo-1620886241733-9dba6e9ef2a8?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=MnwxfDB8MXxyYW5kb218MHx8bWFpemUgY29ybnx8fHx8fDE2OTc4Mzg4OTg&ixlib=rb-4.0.3&q=80&w=500",
    featured: true
  },
  {
    id: 3,
    name: "Bajra (Pearl Millet) Seeds",
    slug: "bajra-seeds",
    description: "Drought-resistant pearl millet varieties that thrive in arid conditions with minimal water requirements, providing excellent nutritional value.",
    category: "Major Seeds",
    imageUrl: "https://images.unsplash.com/photo-1603744440579-77bd8a32a8d9?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=MnwxfDB8MXxyYW5kb218MHx8bWlsbGV0fHx8fHx8MTY5NzgzODc5OA&ixlib=rb-4.0.3&q=80&w=500",
    featured: true
  },
  {
    id: 4,
    name: "Tomato Seed Collection",
    slug: "tomato-seeds",
    description: "Premium tomato varieties including cherry, beefsteak, and paste types, bred for disease resistance and exceptional flavor profiles.",
    category: "Vegetable Seeds",
    imageUrl: "https://images.unsplash.com/photo-1592924357229-34071de7ec7c?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=MnwxfDB8MXxyYW5kb218MHx8dG9tYXRvK3NlZWRzfHx8fHx8MTY5NzgzODc5OA&ixlib=rb-4.0.3&q=80&w=500",
    featured: true
  },
  {
    id: 5,
    name: "Quality Onion Seeds",
    slug: "onion-seeds",
    description: "High-yield onion seed varieties with excellent storage properties and disease resistance, suitable for various Indian climate conditions.",
    category: "Vegetable Seeds",
    imageUrl: "https://images.unsplash.com/photo-1618512496248-a3ba805c1a7b?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=MnwxfDB8MXxyYW5kb218MHx8b25pb258fHx8fHwxNjk3ODM4NTg3&ixlib=rb-4.0.3&q=80&w=500",
    featured: false
  },
  {
    id: 6,
    name: "Premium Chili Seeds",
    slug: "chili-seeds",
    description: "Various chili pepper varieties ranging from mild to extremely hot, bred for consistent productivity and vibrant color development.",
    category: "Vegetable Seeds",
    imageUrl: "https://images.unsplash.com/photo-1563911892437-1feda0179e1b?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=MnwxfDB8MXxyYW5kb218MHx8Y2hpbGl8fHx8fHwxNjk3ODM4OTE1&ixlib=rb-4.0.3&q=80&w=500",
    featured: false
  },
  {
    id: 7,
    name: "Cabbage & Cauliflower Seeds",
    slug: "cabbage-cauliflower-seeds",
    description: "Premium brassica varieties with excellent head formation, disease resistance, and adaptability to different growing seasons.",
    category: "Vegetable Seeds",
    imageUrl: "https://images.unsplash.com/photo-1566486189376-26b1a2e98be7?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=MnwxfDB8MXxyYW5kb218MHx8Y2FiYmFnZXx8fHx8fDE2OTc4Mzg1OTk&ixlib=rb-4.0.3&q=80&w=500",
    featured: false
  },
  {
    id: 8,
    name: "Soybean Seeds",
    slug: "soybean-seeds",
    description: "High-protein soybean varieties with improved oil content and exceptional adaptability to various soil types and climate conditions.",
    category: "Upcoming Seeds",
    imageUrl: "https://images.unsplash.com/photo-1612769254949-811775c05686?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=MnwxfDB8MXxyYW5kb218MHx8c295YmVhbnx8fHx8fDE2OTc4Mzg2MTM&ixlib=rb-4.0.3&q=80&w=500",
    featured: false
  },
  {
    id: 9,
    name: "Cotton Seeds",
    slug: "cotton-seeds",
    description: "Drought-resistant cotton seed varieties that deliver high-quality fiber even under challenging growing conditions with reduced water requirements.",
    category: "Upcoming Seeds",
    imageUrl: "https://images.unsplash.com/photo-1594650448918-33f855bb4929?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=MnwxfDB8MXxyYW5kb218MHx8Y290dG9uK3BsYW50fHx8fHx8MTY5NzgzODc5OA&ixlib=rb-4.0.3&q=80&w=500",
    featured: false
  }
];

// Testimonials data
export const testimonials: Testimonial[] = [
  {
    id: 1,
    name: "Rajesh Kumar",
    title: "Wheat Farmer, Punjab",
    comment: "Varsha Seeds' wheat variety has transformed my farm's productivity. The disease resistance is remarkable, and I've seen a 30% increase in yield compared to previous seasons.",
    rating: 5,
    imageUrl: "https://images.unsplash.com/photo-1560343776-97e7d202ff0e?crop=entropy&cs=tinysrgb&fit=crop&fm=jpg&h=56&ixid=MnwxfDB8MXxyYW5kb218MHx8ZmFybWVyfHx8fHx8MTY5NzgzOTAzMw&ixlib=rb-4.0.3&q=80&utm_campaign=api-credit&utm_medium=referral&utm_source=unsplash_source&w=56"
  },
  {
    id: 2,
    name: "Sunita Patel",
    title: "Vegetable Grower, Gujarat",
    comment: "The vegetable seed collection from Varsha Seeds has consistently delivered excellent results. The germination rate is nearly perfect, and the yields have exceeded my expectations.",
    rating: 4.5,
    imageUrl: "https://images.unsplash.com/photo-1591025810539-a321000c2096?crop=entropy&cs=tinysrgb&fit=crop&fm=jpg&h=56&ixid=MnwxfDB8MXxyYW5kb218MHx8ZmFybWVyfHx8fHx8MTY5NzgzOTA1MA&ixlib=rb-4.0.3&q=80&utm_campaign=api-credit&utm_medium=referral&utm_source=unsplash_source&w=56"
  },
  {
    id: 3,
    name: "Prakash Singh",
    title: "Rice Farmer, West Bengal",
    comment: "I've been using Varsha Seeds' rice varieties for five seasons now. Their drought-resistant varieties have helped me maintain good yields even during challenging weather conditions.",
    rating: 5,
    imageUrl: "https://images.unsplash.com/photo-1597320554048-60857bb30d97?crop=entropy&cs=tinysrgb&fit=crop&fm=jpg&h=56&ixid=MnwxfDB8MXxyYW5kb218MHx8ZmFybWVyfHx8fHx8MTY5NzgzOTA2NA&ixlib=rb-4.0.3&q=80&utm_campaign=api-credit&utm_medium=referral&utm_source=unsplash_source&w=56"
  }
];

// Features data
export const features = [
  {
    icon: "seedling",
    title: "Premium Quality Seeds",
    description: "Rigorously tested seeds with high germination rates and yield potential."
  },
  {
    icon: "microscope",
    title: "Advanced Research",
    description: "Continuous innovation through our state-of-the-art research facilities."
  },
  {
    icon: "leaf",
    title: "Sustainable Practices",
    description: "Environmentally conscious methods ensuring soil health and biodiversity."
  },
  {
    icon: "hands-helping",
    title: "Farmer Support",
    description: "Comprehensive assistance from planting to harvest for optimal results."
  }
];

// Process steps data
export const processSteps = [
  {
    number: 1,
    title: "Research & Development",
    description: "Developing robust seed varieties through scientific breeding programs."
  },
  {
    number: 2,
    title: "Controlled Cultivation",
    description: "Growing seeds in optimal conditions for maximum genetic potential."
  },
  {
    number: 3,
    title: "Quality Processing",
    description: "Advanced cleaning, sorting, and treatment for perfect seed quality."
  },
  {
    number: 4,
    title: "Rigorous Testing",
    description: "Thorough testing for germination rate, purity, and vigor before packaging."
  }
];

// Services data
export const services = [
  {
    icon: "filter",
    title: "Seed Cleaning & Grading",
    description: "State-of-the-art equipment for precise cleaning and grading of all seed types."
  },
  {
    icon: "shield-alt",
    title: "Seed Treatment",
    description: "Advanced treatment processes to enhance seed protection and performance."
  },
  {
    icon: "box",
    title: "Seed Packaging",
    description: "Custom packaging solutions to maintain seed viability and enhance shelf life."
  },
  {
    icon: "flask",
    title: "Seed Testing",
    description: "Comprehensive testing services for germination rate, purity, and vigor."
  }
];

// Company statistics
export const stats = [
  { value: "35+", label: "Years of Experience" },
  { value: "100K+", label: "Satisfied Farmers" },
  { value: "50+", label: "Seed Varieties" },
  { value: "12", label: "Research Facilities" }
];

// CTA metrics
export const metrics = [
  { value: "98%", label: "Germination Rate" },
  { value: "15-30%", label: "Yield Increase" },
  { value: "24/7", label: "Expert Support" },
  { value: "100%", label: "Satisfaction" }
];
